import apiClient from '../utils/axios-config';
import { logger } from '../utils/logger';

export interface OutfitEnrichment {
  howToWear: string[];
  styleNotes: string;
  relatedOutfits: Array<{
    outfitId: string;
    imageUrl: string;
    title: string;
    description: string;
  }>;
}

class ContentEnrichService {
  async getOutfitEnrichment(outfitId: string): Promise<OutfitEnrichment> {
    try {
      const response = await apiClient.get(`/content/enrich/${outfitId}`);
      return response.data.enrichment || response.data;
    } catch (error) {
      logger.apiError('fetching outfit enrichment', error);
      throw error;
    }
  }
}

export default new ContentEnrichService();
